// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_34Xsc","menu-link":"_1bnML"};